export const environment = {
    production: true,
    baseURl : 'https://apiqa.residentiq.com',
    dashboardUrl : 'https://qa-portal.residentiq.com',
    screeningUrl : 'https://qa-screening.residentiq.com',
  };
  